import { useEffect, useState } from 'react';

const IntroVideo = ({ onVideoEnd }) => {
    const [fadeOut, setFadeOut] = useState(false);
    const [isVisible, setIsVisible] = useState(true);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkIsMobile = () => {
            setIsMobile(window.innerWidth <= 768); // puedes ajustar el tamaño si lo deseas
        };

        checkIsMobile();
        window.addEventListener('resize', checkIsMobile);

        return () => {
            window.removeEventListener('resize', checkIsMobile);
        };
    }, []);

    useEffect(() => {
        let timeout;
        if (fadeOut) {
            timeout = setTimeout(() => {
                setIsVisible(false);
                onVideoEnd();
            }, 1000);
        }
        return () => clearTimeout(timeout);
    }, [fadeOut, onVideoEnd]);

    if (!isVisible) return null;

    const videoSrc = isMobile
        ? '/recursos/EMPATICA-EMPATICA-OPEN-Movil.mp4'
        : '/recursos/EMPATICA-OPEN.mp4';

        console.log("isMobile:", isMobile, "Video src:", videoSrc);

    return (
        <div className="fixed inset-0 z-50 bg-black flex items-center justify-center transition-opacity duration-1000">
            <video
                autoPlay
                muted
                playsInline
                onEnded={() => setFadeOut(true)}
                className={`w-full h-full object-cover transition-opacity duration-1000 ${
                    fadeOut ? 'opacity-0' : 'opacity-100'
                }`}
                aria-label="Intro animación de Empática"
            >
                <source src={videoSrc} type="video/mp4" />
                Tu navegador no soporta la reproducción de video.
            </video>
        </div>
    );
};

export default IntroVideo;
